import React from 'react';import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SoftwareProductsTable } from '.';

const SoftwareProducts = ({ softwareProductsList, editMode = false }) => {
    const premiums = softwareProductsList.filter((item) => item.type === "Premium");
    const subscriptions = softwareProductsList.filter((item) => item.type === "Subscription");
    const listToDisplay = softwareProductsList.filter((item) => !(item.name.includes("2-4") || item.name.includes("rabattert")))
    return (
        <div className="subscriptionTable">
            <SoftwareProductsTable softwareProductsList={listToDisplay} tableName='Abonnement' className='subscriptionTable' />
        </div>
    );
};



export default SoftwareProducts;